<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue'
import { RouterView } from 'vue-router'
import ScrollToTop from './components/ScrollToTop.vue'
import WhatsAppButton from './components/WhatsAppButton.vue'
import Lenis from 'lenis'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

onMounted(() => {
  // Initialize Lenis
  const lenis = new Lenis({
    lerp: 0.1, // Smoothness value
    wheelMultiplier: 1.0,
  })

  // Sync ScrollTrigger with Lenis' scroll updates
  lenis.on('scroll', ScrollTrigger.update)

  // Add Lenis's requestAnimationFrame (raf) to GSAP's ticker
  gsap.ticker.add((time) => {
    lenis.raf(time * 1000)
  })

  // Turn off GSAP's default lag smoothing to avoid conflicts with Lenis
  gsap.ticker.lagSmoothing(0)

  onUnmounted(() => {
    lenis.destroy()
  })
})
</script>
<template>
  <link href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined" rel="stylesheet" />
  <RouterView />
  <ScrollToTop />
  <WhatsAppButton />
</template>

<style scoped>
body {
  margin: 0;
  padding: 0;
}

/* main {
  margin-top: 90px;
} */
</style>
